module.exports = "/legacy/5a4b9a39a4ef94eb7a67fb7aeff0402d.svg";